import { effectIconKey, type ThemeImageKey } from "../themes/imageKeys.js";

/** 모듈을 대표하는 UI 아이콘. 그리드 타일과 동일한 기능 아이콘을 우선 사용한다. */
export function modulePresentationIconKey(definitionId: string): ThemeImageKey {
  return effectIconKey(definitionId) ?? "icon_tab_codex";
}

/** 도감의 모듈 아이콘. 등록된 기능 아이콘을 우선 사용한다. */
export function moduleCodexIconKey(definitionId: string): ThemeImageKey {
  return modulePresentationIconKey(definitionId);
}
